export default __webpack_public_path__ + "static/media/img-10.fe61a8ea.jpg";